"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportSourceType = exports.GameStatus = exports.SportType = void 0;
var SportType;
(function (SportType) {
    SportType["Soccer"] = "soccer";
    SportType["Basketball"] = "basketball";
    SportType["IceHockey"] = "icehockey";
    SportType["Handball"] = "handball";
    SportType["Other"] = "other";
})(SportType = exports.SportType || (exports.SportType = {}));
var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["FIXTURE"] = 'Fixture'] = "FIXTURE";
    GameStatus[GameStatus["PLAYED"] = 'Played'] = "PLAYED";
    GameStatus[GameStatus["PLAYING"] = 'Playing'] = "PLAYING";
    GameStatus[GameStatus["CANCELLED"] = 'Cancelled'] = "CANCELLED";
    GameStatus[GameStatus["POSTPONED"] = 'Postponed'] = "POSTPONED";
    GameStatus[GameStatus["SUSPENDED"] = 'Suspended'] = "SUSPENDED";
})(GameStatus = exports.GameStatus || (exports.GameStatus = {}));
var ImportSourceType;
(function (ImportSourceType) {
    ImportSourceType["SportRadar"] = "sportradar";
    ImportSourceType["Opta"] = "opta";
})(ImportSourceType = exports.ImportSourceType || (exports.ImportSourceType = {}));
